import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface DashboardFeature {
  icon: string;
  title: string;
  description: string;
  image: string;
  alt: string;
}

interface ProjectDashboardProps {
  features: DashboardFeature[];
}

const ProjectDashboard = ({ features }: ProjectDashboardProps) => {
  return (
    <div className="space-y-6 md:space-y-8">
      <div className="text-center">
        <h3 className="font-headline text-xl md:text-2xl font-bold text-foreground mb-2">
          Your Project Management Dashboard
        </h3>
        <p className="font-body text-muted-foreground max-w-2xl mx-auto">
          Real-time visibility into every aspect of your project journey
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 lg:gap-8">
        {features.map((feature, index) => (
          <div
            key={index}
            className="bg-card rounded-lg overflow-hidden shadow-soft hover:shadow-strong transition-shadow duration-300"
          >
            <div className="relative h-48 overflow-hidden">
              <AppImage
                src={feature.image}
                alt={feature.alt}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-secondary/80 to-transparent"></div>
              <div className="absolute bottom-4 left-4 flex items-center space-x-3">
                <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                  <Icon
                    name={feature.icon as any}
                    size={20}
                    className="text-primary-foreground"
                  />
                </div>
                <h4 className="font-body font-semibold text-white text-lg">
                  {feature.title}
                </h4>
              </div>
            </div>
            <div className="p-6">
              <p className="font-body text-foreground leading-relaxed">
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectDashboard;